import { render } from "./Date_wise_attendance.vue?vue&type=template&id=08d723d1&ts=true"
import script from "./Date_wise_attendance.vue?vue&type=script&lang=ts"
export * from "./Date_wise_attendance.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__